export const  translations = {
    en: {
        contact: "Contact",
        our_games: "Our Games",
        send: "Send",
        sending: "Sending...",
        name: "Name",
        email: "Email",
        message: "Message",
        success: "Your message has been sent.",
        submitError: "Something went wrong. Please try again.",
        errors: {
            nameRequired: "Name is required",
            emailRequired: "Email is required",
            emailInvalid: "Enter a valid email",
            messageRequired: "Message is required",
            messageShort: "Message should be at least 10 characters",
        },
        successTitle: "Message sent",
        successDesc: "Thanks! We’ll get back to you soon.",
        about: "About",
        about1Title: "We make games\nyou want to play",
        about1Text: "Our games are designed to\nbe played again and again",
        about1Tag: "Fun • Engaging • Replayable",
        about2Title: "We test games\nin the field",
        about2Text: "Each game is refined\nuntil it works just right.",
        about2Tag: "Tested • Balanced • Polished",
        about3Title: "Bringing people\ntogether matters to us",
        about3Text: "Games are time with\nfriends and family",
        about3Tag: "Together • Inclusive • Meaningful",
        how: "How we make games",
        howText: "We go all the way from the first idea to a game you want to play again and again",
        idea: "Idea",
        ideaText: "We look for and test ideas that captivate",
        design: "Design",
        designText: "We come up with the mechanics, style and visuals",
        prototype: "Prototype",
        prototypeText: "We build a prototype and test that it works",
        test: "Testing",
        testText: "We test, balance and improve — until it’s just right",
        production: "Production",
        productionText: "We polish and release the game you love",
        playersCount: "Players count",
        timeMinutes: "Time for the game",
        age: "Age",
        gallery: "Gallery",
        galleryDescription: "A collection of media from playtesting sessions, events and more",
        downloads: "Downloads",
        downloadsDescription: "Rules, print-and-play files, and other resources to get the most out of your game",
        download: "Download",
        series: "Series",
        seriesDescription: "Other games in series {series} — explore the full collection",
        addons: "Expansions & Add-ons",
        addonsDescription: "Enhance your game with official add-ons",
        notFoundTitle: "Page not found",
        notFoundDesc: "The page you're looking for doesn't exist or has been moved.",
        notFoundBtn: "Back to home",
    },
    ru: {
        contact: "Контакт",
        our_games: "Наши игры",
        send: "Отправить",
        sending: "Отправка...",
        name: "Имя",
        email: "Email",
        message: "Сообщение",
        success: "Ваше сообщение отправлено.",
        submitError: "Что-то пошло не так. Попробуйте еще раз.",
        errors: {
            nameRequired: "Введите имя",
            emailRequired: "Введите email",
            emailInvalid: "Введите корректный email",
            messageRequired: "Введите сообщение",
            messageShort: "Сообщение должно быть не короче 10 символов",
        },
        successTitle: "Сообщение отправлено",
        successDesc: "Спасибо! Мы скоро свяжемся с вами.",
        about: "О нас",
        about1Title: "Мы делаем игры,\nв которые хочется играть",
        about1Text: "В наши игры хочется\nиграть снова и снова",
        about1Tag: "Весело • Увлекательно • Реиграбельно",
        about2Title: "Мы проверяем\nнаши игры в деле",
        about2Text: "Каждая игра дорабатывается,\nпока всё не работает как надо.",
        about2Tag: "Проверено • Сбалансировано",
        about3Title: "Нам важно\nсобирать людей вместе",
        about3Text: "Игры — это время\nс друзьями и семьёй",
        about3Tag: "Вместе • Инклюзивно • Значимо",
        how: "Как мы делаем игры",
        howText: "Мы проходим весь путь — от первой идеи до игры, в которую хочется играть снова и снова",
        idea: "Идея",
        ideaText: "Ищем и проверяем идеи, которые захватывают",
        design: "Дизайн",
        designText: "Придумываем механику, стиль и визуал",
        prototype: "Прототип",
        prototypeText: "Собираем прототип и проверяем, что он работает",
        test: "Тестирование",
        testText: "Проверяем, балансируем и улучшаем — пока не станет идеально",
        production: "Производство",
        productionText: "Доводим до финала и выпускаем угру, которую вы любите",
        playersCount: "Количество игроков",
        timeMinutes: "Время игры",
        age: "Возраст",
        gallery: "Галерея",
        galleryDescription: "Коллекция медиа из сессий тестирования, событий и многого другого",
        downloads: "Загрузки",
        downloadsDescription: "Правила, файлы для печати и другие материалы, чтобы получить от игры максимум",
        download: "Скачать",
        series: "Серия",
        seriesDescription: "Другие игры серии {series} — исследуйте всю коллекцию",
        addons: "Дополнения",
        addonsDescription: "Расширьте игру с помощью официальных дополнений",
        notFoundTitle: "Страница не найдена",
        notFoundDesc: "Такой страницы не существует или она была перемещена.",
        notFoundBtn: "На главную",
    },
    he: {
        contact: "צור קשר",
        our_games: "המשחקים שלנו",
        send: "שלח",
        sending: "שולח...",
        name: "שם",
        email: "אימייל",
        message: "הודעה",
        success: "ההודעה נשלחה בהצלחה.",
        submitError: "משהו השתבש. נסו שוב.",
        errors: {
            nameRequired: "יש להזין שם",
            emailRequired: "יש להזין אימייל",
            emailInvalid: "יש להזין אימייל תקין",
            messageRequired: "יש להזין הודעה",
            messageShort: "ההודעה חייבת להכיל לפחות 10 תווים",
        },
        successTitle: "ההודעה נשלחה",
        successDesc: "תודה! נחזור אליך בקרוב.",
        about: "אודות",
        about1Title: "אנחנו עושים\nמשחקים שאתם רוצים לשחק",
        about1Text: "המשחקים שלנו מעוצבים כך\nשתרצו לשחק בהם שוב ושוב",
        about1Tag: "כיף • מרתק • ניתן לשחק שוב",
        about2Title: "אנחנו בודקים\nאת המשחקים בשטח",
        about2Text: "כל משחק משודרג עד שהוא\nעובד בדיוק כמו שצריך.",
        about2Tag: "נבדק • מאוזן • מלוטש",
        about3Title: "חשוב לנו\nלאסוף אנשים יחד",
        about3Text: "משחקים הם זמן עם\nחברים ובני משפחה",
        about3Tag: "ביחד • כוללני • משמעותי",
        how: "איך אנחנו עושים משחקים",
        howText: "אנחנו עוברים את כל הדרך מהרעיון הראשון למשחק שאתם רוצים לשחק בו שוב ושוב",
        idea: "רעיון",
        ideaText: "אנחנו מחפשים ובודקים רעיונות שמרתקים",
        design: "עיצוב",
        designText: "אנחנו ממציאים את המכניקה, הסגנון והויזואל",
        prototype: "פרוטוטייפ",
        prototypeText: "אנחנו בונים אבטיפוס ובודקים שהוא עובד",
        test: "בדיקה",
        testText: "אנחנו בודקים, מאזנים ומשפרים — עד שזה פשוט מושלם",
        production: "ייצור",
        productionText: "אנחנו מלוטשים ומשחררים את המשחק שאתם אוהבים",
        playersCount: "מספר שחקנים",
        timeMinutes: "זמן למשחק",
        age: "גיל",
        gallery: "גלריה",
        galleryDescription: "אוסף מדיה מימי הבדיקה, אירועים ועוד",
        downloads: "הורדות",
        downloadsDescription: "חוקים, קבצים להדפסה וחומרים נוספים להפקת המיטב מהמשחק שלכם",
        download: "הורדה",
        series: "סדרה",
        seriesDescription: "משחקים נוספים בסדרה {series} — חקרו את כל האוסף",
        addons: "הרחבות",
        addonsDescription: "שדרגו את המשחק עם הרחבות ותוספות",
        notFoundTitle: "הדף לא נמצא",
        notFoundDesc: "הדף שחיפשתם אינו קיים או הועבר למקום אחר.",
        notFoundBtn: "חזרה לדף הבית",
    }
};